import type { AppTheme } from '../../theme';
import type { CSSProperties } from 'react';
export const previewFrameStyle = (width: number, overlay = false): CSSProperties => overlay
  ? { display: 'block', width, minWidth: width, maxWidth: 'none', height: '100%', margin: '0 auto', border: 0 }
  : { position: 'fixed', left: -20000, top: -20000, width, height: 1200, border: 0, pointerEvents: 'none' };

export const previewStageStyle = (overlay: boolean, editing: boolean): CSSProperties => overlay
  ? { position: 'absolute', left: 0, top: 'var(--studio-dialog-tools-height, 72px)', bottom: 0, width: editing ? 'calc(100% - min(360px, 45vw))' : '100%', overflowX: 'auto', overflowY: 'hidden', zIndex: 10000 }
  : { position: 'absolute', width: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' };

export const previewSectionStyle: CSSProperties = { display: 'flex', flexDirection: 'column', height: 640, minHeight: 0 };

export const previewSourceStyle = (width: number, detached: boolean, interactive = false): CSSProperties => detached
  ? { position: 'fixed', left: -20000, top: -20000, width, height: 1200, pointerEvents: interactive ? undefined : 'none' }
  : { display: 'flex', flexDirection: 'column', height: 1200, minHeight: 500, width: '100%', pointerEvents: interactive ? undefined : 'none' };

export const previewErrorStyle = (theme: AppTheme): CSSProperties => ({ backgroundColor: theme.colors.card, color: theme.colors.text, border: `1px solid ${theme.colors.border}` });
